type InsightType =
  | "cumulative-people"
  | "occupancy-people"
  | "queue-people"
  | "cumulative-shopping-cart"
  | "occupancy-shopping-cart"
  | "queue-shopping-cart"
  | "cumulative-vehicle"
  | "occupancy-vehicle"
  | "queue-vehicle"
  | "slip-and-fall"
  | "crowd-count"
  | "visitor-area-traffic";
type DataType =
  | "PEOPLE_COUNT"
  | "QUEUE_MANAGEMENT"
  | "SLIP_AND_FALL"
  | "CROWD_COUNT"
  | "SHOPPING_CART_COUNT"
  | "SHOPPING_CART_QUEUE_MANAGEMENT"
  | "VEHICLE_COUNT"
  | "VEHICLE_QUEUE_MANAGEMENT";

type DeviceData = {
  locationId: string;
};

type GroupedData = Record<string, Record<string, DeviceData[]>>;

const DEFAULT_INSIGHT_TYPE: InsightType = "cumulative-people";
const DEFAULT_DATA_TYPE: DataType = "PEOPLE_COUNT";

const titleToInsightTypeMap: Record<string, InsightType> = {
  "Cumulative people count": "cumulative-people",
  "People occupancy": "occupancy-people",
  "People queues": "queue-people",
  "Visitor area traffic": "visitor-area-traffic",
  "Crowd counting": "crowd-count",
  "Slip & fall": "slip-and-fall",
  "Cumulative shopping cart count": "cumulative-shopping-cart",
  "Shopping carts in use": "occupancy-shopping-cart",
  "Shopping cart queues": "queue-shopping-cart",
  "Cumulative vehicle count": "cumulative-vehicle",
  "Vehicle occupancy": "occupancy-vehicle",
  "Vehicle queues": "queue-vehicle"
};

const titleToDataTypeMap: Record<string, DataType> = {
  "Cumulative people count": "PEOPLE_COUNT",
  "People occupancy": "PEOPLE_COUNT",
  "People queues": "QUEUE_MANAGEMENT",
  "Visitor area traffic": "QUEUE_MANAGEMENT",
  "Slip & fall": "SLIP_AND_FALL",
  "Crowd counting": "CROWD_COUNT",
  "Cumulative shopping cart count": "SHOPPING_CART_COUNT",
  "Shopping carts in use": "SHOPPING_CART_COUNT",
  "Shopping cart queues": "SHOPPING_CART_QUEUE_MANAGEMENT",
  "Cumulative vehicle count": "VEHICLE_COUNT",
  "Vehicle occupancy": "VEHICLE_COUNT",
  "Vehicle queues": "VEHICLE_QUEUE_MANAGEMENT"
};

export const useInsightTypeConverter = () => {
  const labelToInsightType = (label: string): InsightType => {
    return titleToInsightTypeMap[label] ?? DEFAULT_INSIGHT_TYPE;
  };

  const labelToDataType = (label: string): DataType => {
    return titleToDataTypeMap[label] ?? DEFAULT_DATA_TYPE;
  };

  const getGroupByTypeAndLocationId = (
    data: GroupedData,
    type: string,
    targetLocationId: string
  ): Record<string, DeviceData[]> | null => {
    const group = data?.[labelToDataType(type)];
    if (!group) return null;

    const entry = Object.entries(group).find(([, items]) =>
      items.some((item) => item.locationId === targetLocationId)
    );

    return entry ? { [entry[0]]: entry[1] } : group;
  };

  return {
    labelToInsightType,
    getGroupByTypeAndLocationId
  };
};
